export { namespace } from './actions';
import { Status, ActionType } from './actions';

const initialState = {
  status: Status.INITIAL,
  data: []
}

export default function featureFlagConfigReducer(state = initialState, action) {
  
  switch (action.type) {
    case ActionType.SET_FEATURE_FLAG_CONFIG:
      {
        const { featureFlagConfig } = action.payload;
        return {
          ...state,
          status: Status.LOADED,
          data: [...featureFlagConfig]
        }
      } 
    default:
      return state;
  }
}
